import { useState, useEffect } from 'react';

import ModalBase from "./ModalBase";
import UserApi from "../../api/UserApi";
import CopyBtn from "../common/CopyBtn";

const CACHE_INFO = {};

const ExpertConnectionPop = props => {
    const { onClose, ownerId } = props;
    const [info, setInfo] = useState({});

    useEffect(() => {
        if (CACHE_INFO[ownerId]) return setInfo(CACHE_INFO[ownerId])
        UserApi.getExpertInfo(ownerId).then(rslt => {
            const newInfo = {
                phone : rslt.expert_phone ?? '',
                email : rslt.expert_email ?? '',
                kakao : rslt.expert_kakao_id ?? ''
            }
            setInfo(newInfo);
            CACHE_INFO[ownerId] = newInfo;
        })
    }, [])

    return (
        <ModalBase title={"전문가 정보"} onClose={onClose}>
            <div className="modal-expert-info">
                <dl>
                    <dt>연락처</dt>
                    <dd>
                        <span>{info.phone}</span>
                        <CopyBtn text={info.phone} />
                    </dd>
                </dl>
                <dl>
                    <dt>이메일</dt>
                    <dd>
                        <span>{info.email}</span>
                        <CopyBtn text={info.email} />
                    </dd>
                </dl>
                <dl>
                    <dt>카카오톡</dt>
                    <dd>
                        <span>{info.kakao}</span>
                        <CopyBtn text={info.kakao} />
                    </dd>
                </dl>
            </div>
        </ModalBase>
    )
}

export default ExpertConnectionPop;